// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4e2555a9","453":"ac58f522","732":"5e1cac62","977":"a0640d81"}[chunkId] + ".chunk.js";
};